// extracted by mini-css-extract-plugin
export default {"copy_icon":"ResultsCopyIcon_copy_icon__iGsz0","icon":"ResultsCopyIcon_icon__+6BsO"};